export const SCHEDULE_TIME_COMBINATIONS: { hour: number; minute: number }[] = [
  { hour: 8, minute: 0 },
  { hour: 10, minute: 30 },
  { hour: 13, minute: 0 },
  { hour: 15, minute: 30 },
];
